<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page :title="title">
      <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess()" >
         <w-flex gap="3">
           <div class="box xs6">
            <template v-if="form.id > 0">
               <br>
               <w-input label="Nombor Batch *" v-model="form.no_batch" readonly :validators="[validators.required]"/>
            </template>
            <template v-else>
               <z-select class="mt4" :items="se_pemungutan" @input="pilihNoBatch" label="Nombor Batch *"  v-model="form.se_pemungutan_id" :validators="[validators.required]"/>
            </template>
            <div class="spacer"></div>
            <br>
            <w-input label="Nombor Ejakulasi *" v-model="form.lkp_ejakulasi_label" readonly :validators="[validators.required]"/>
            <div class="spacer"></div>
            <w-input class="mt4" label="Tarikh Pengeluaran *" type="date" v-model="form.tarikh" :validators="[validators.required]"/>
            <div class="spacer"></div>
            <br>
            <w-input label="Skor Keaktifan (0-5)" type="number" v-model="form.stor_keaktifan" @keyup="skorKeaktifan()"/>
            <div class="spacer"></div>
            <br>
            <w-input label="% Motiliti Progresif*" type="text" v-model="form.motiliti" :validators="[validators.required]"/>
            <div class="spacer"></div>
            <br>
            <z-money2 label="Kepekatan Sperma (/ml) *" @input="countJumlahStraw" v-model:originalValue="form.kepekatan_sperma" name="kepekatan_sperma" :validators="[validators.required]"/>
            <div class="spacer"></div>
            <br>
            <z-money2 label="Kepekatan Sperma (Per straw) * (X10^6)"  @input="countJumlahStraw" v-model:originalValue="form.kepekatan_straw" name="kepekatan_straw" :validators="[validators.required]"/>
            <div class="spacer"></div>
            <br>
            <w-input label="Isipadu Semen (ml) * (X10^6)" type="number" v-model="form.isipadu" readonly :validators="[validators.required]"/>
            <div class="spacer"></div>
            <br>
            <w-input
              class="mb2"
              label="Nama Pemeriksa dan Penilai *"
              label-position="inside"
              inner-icon-right="wi-search"
              v-model="form.name" @click="pengguna()" :validators="[validators.required]">
            </w-input>
           </div>

           <div class="box"></div>

           <div class="box xs6">
            <br>
            <w-input label="ID Ternakan *" v-model="form.ternakan" readonly :validators="[validators.required]"/>
            <div class="spacer"></div>
            <br>
            <w-input label="Isipadu Extender (ml)" type="text" v-model="form.isipadu_extender" readonly/>
            <div class="spacer"></div>
            <br>
            <w-input label="Jumlah Straw Dipungut" type="text" v-model="form.jumlah_straw" readonly/>
            <div class="spacer"></div>
            <br>
            <w-input label="Jumlah Extender A (ml)" type="number" v-model="form.jumlah_extender_a"/>
            <div class="spacer"></div>
            <br>
            <w-input label="Jumlah Extender B (ml)" type="number" v-model="form.jumlah_extender_b"/>
            <div class="spacer"></div>
            <br>
            <template v-if="wajib == 1">
               <w-input label="% Motiliti Progresif (sejuk)" type="number" v-model="form.motiliti_sejuk"/>
               <div class="spacer"></div>
               <br>
               <w-input label="% Motiliti Progresif (beku)" type="number" v-model="form.motiliti_beku"/>
               <div class="spacer"></div>
               <br>
            </template>
            <template v-else>
               <w-input label="% Motiliti Progresif (sejuk)" type="number" v-model="form.motiliti_sejuk"/>
               <div class="spacer"></div>
               <br>
               <w-input label="% Motiliti Progresif (beku)" type="number" v-model="form.motiliti_beku"/>
               <div class="spacer"></div>
               <br>
            </template> 
            <!-- @keyup.stop="keydown" -->
            <!-- <w-input label="Jumlah Straw Dikeluarkan*" type="number" v-model="form.jumlah_pengeluaran" @keyup="checkPengeluaran()" :maxlength="form.jumlah_straw" :validators="[validators.required]"/> -->
            <w-input
              label="Jumlah Straw Dikeluarkan*"
              type="number"
              v-model="form.jumlah_pengeluaran"
              :maxlength="form.jumlah_straw"
              :validators="[form.lkp_status_id == 24 ? null : validators.required]"
            />
            <div class="spacer"></div>
            <z-select class="mt4" :items="status" label="Status *" v-model="form.lkp_status_id" @input="checkWajib()" :validators="[validators.required]"/>
           </div>
         </w-flex>
        
         <template v-if="wajib == 1">
            <w-textarea class="mt4"  label="Catatan *"  v-model="form.catatan" :validators="[validators.required]"/>
         </template>
         <template v-else>
            <w-textarea class="mt4"  label="Catatan"  v-model="form.catatan"/>
         </template>

        <w-flex class="mt3" wrap align-center justify-end v-if="$zutil.anyRole(['1', '3', '11'])">
            <!-- <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                      <w-button class="my1" v-on="on"  :loading="form.submitted && !form.sent" @click="send(2); onSuccess()"><div style="width: 6px"></div> 
                    <w-icon class="mr1" md >fal fa-save</w-icon>
                </w-button>
                </template>
               SIMPAN
            </w-tooltip> -->
            <w-button class="my1"   :loading="form.submitted && !form.sent" @click="send(2); onSuccess()">
          <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
        </w-button>
            &nbsp;
            <!-- <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                      <w-button class="my1" v-on="on" type="submit" bg-color="success" :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(1)" ><div style="width: 6px"></div> 
                    <w-icon class="mr1" md >fal fa-paper-plane</w-icon>
                </w-button>
                </template>
               HANTAR
            </w-tooltip> -->
            <w-button class="my1" bg-color="success" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(1)">
          <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
        </w-button>
        </w-flex>
        <div class="mt2 text-left">
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
      </div>
      </w-form>
	  </z-page>
    <w-dialog
      v-model="dialog.show"
      :fullscreen="dialog.fullscreen"
      :width="dialog.width"
      :persistent="dialog.persistent"
      :persistent-no-animation="dialog.persistentNoAnimation"
      title-class="primary-dark1--bg white">
      <template #title>
         <w-icon class="mr2">fal fa-cog</w-icon>
         Pilih Nama Pemeriksa dan Penilai 
      </template>

      <w-form 
         ref="form" 
         v-model="dialog.valid"
         @validate="submit"
         @success="success"
      >
          <w-flex justify-center align-center>
              <div class="xs8">
                  <w-input
                      label="No id | Nama"
                      v-model="carian_profil.q"
                  >
                  </w-input>
              </div>
              <div class="xs4">
                  <w-button class="ml1" @click="cariProfil">Cari</w-button>

                  <w-button 
                      class="ml1" 
                      @click="tambahPrfile()"
                      v-if="$zutil.anyRole(['1', '3', '11'])"
                      >
                      Tambah
                  </w-button>
              </div>
          </w-flex>
        <div class="w-table-wrap" style="max-height: 400px;">
          <div class="table-profil-scrol">
          <table class="w-table" color="light" >
            <thead>
              <tr>
                <th class="w-table__header  text-left" width="1%">No</th>
                <th class="w-table__header  text-left">Nama</th>
                <th class="w-table__header  text-left">Email</th>
                <th class="w-table__header  text-left">Nombor Telefon</th>
                <th class="w-table__header  text-left">Pilih</th>
                <th class="w-table__header  text-left">Padam</th>
              </tr>
            </thead>

            <tbody>
              <template v-if="user_list.length == 0">
                <tr class="w-table__row" >
                  <td class="w-table__cell text-left" colspan="20"> Tiada Data.</td>
                </tr>
              </template>
              <template v-for="(dt, ind) in user_list">
                <tr class="w-table__row" >
                  <td class="w-table__cell text-left" >{{ind+1}}</td>
                  <td class="w-table__cell text-left" >{{dt.no_id}} | {{dt.label}}</td>
                  <td class="w-table__cell text-left" >{{dt.email}}</td>
                  <td class="w-table__cell text-left" >{{dt.no_tel}}</td>
                  <td class="w-table__cell text-center">
                    <template v-if="form.pembekal_id == dt.value">
                       <w-radio
                        class="mr2"
                        v-model="form.pembekal_id"
                        @click="pilihProfil(dt)"
                      ></w-radio>
                    </template>
                    <template v-else>
                      <w-radio
                        class="mr2"
                        @click="pilihProfil(dt)"
                      ></w-radio>
                    </template>

                  </td>
                  <td class="w-table__cell text-left" >
                     <w-button class="fs-2" bg-color="error-dark1" dark tile @click="destroy1(dt.value)">
                       <w-icon xs class="mr2">fal fa-trash</w-icon>
                     </w-button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
          </div>
        </div>
      </w-form>
      <template #actions>
         <div class="spacer" />
         <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">TUTUP</w-button>
      </template>
    </w-dialog>
    <w-dialog
      v-model="dialog_add.show"
      :fullscreen="dialog_add.fullscreen"
      :width="dialog_add.width"
      :persistent="dialog_add.persistent"
      :persistent-no-animation="dialog_add.persistentNoAnimation"
      title-class="primary-dark1--bg white">
      <template #title>
         <w-icon class="mr2">fal fa-cog</w-icon>
         Tambah Nama Pemeriksa dan Penilai
      </template>

      <w-form 
         ref="form" 
         v-model="dialog_add.valid"
         @validate="submitProfil"
         @success="success"
      >
      <div class="spacer"></div>
        <w-flex wrap :gap="2">
          <div class="grow mb4" style="min-width: 200px">
            <w-input
           outline
           label="No. Kad Pengenalan *"
           class="mt3"
           type="text"
           placeholder="No. Kad Pengenalan"
           name="no_id"
           v-model="form_profil.no_id"
           :validators="[validators.required]"
         />
            <div class="spacer"></div>
            <br>
            <w-input
            outline
            label="Emel *"
            class="mt3"
            type="email"
            placeholder="Sila Masukkan Emel"
            name="email"
            v-model="form_profil.email"
            :validators="[validators.required, validators.email]"
         />
          </div>
          <div class="grow mb4" style="min-width: 200px">
            <w-input
           outline
           label="Nama Penuh *"
           class="mt3"
           type="text"
           placeholder="Nama Penuh"
           name="name"
           v-model="form_profil.name"
           :validators="[validators.required]"
         />
            <div class="spacer"></div>
            <br>
            <w-input
             outline
             label="Nombor Telefon *"
             class="mt3"
             type="tel"
             placeholder="Sila Masukkan Nombor Telefon"
             name="no_tel"
             v-model="form_profil.no_tel"
             :validators="[validators.required, validators.numeric]"
         />
          </div>
        </w-flex>
        <!-- <div class="spacer"></div>
        <w-textarea 
            outline 
            label="Alamat*"
            placeholder="Sila Masukkan Alamat"
            class="mt3"
            name="alamat"
            v-model="form_profil.alamat"
            type="text-area"
            :validators="[validators.required]"/>
        <div class="spacer"></div>
        <br>
        <template v-if = "form.p == 1">
         <w-select 
            outline
            :items="poskod" 
            label="Poskod"  
            v-model="form.lkp_poskod_id"
            @input="checkPoskod()"
            />
        </template>
        <template v-else>
          <w-input
             outline
             label="Poskod"
             class="mt3"
             type="tel"
             placeholder="Sila Masukkan Poskod"
             name="poskod"
             v-model="form_profil.kode"
             @change="getPoskodUtama()"
             :validators="[validators.required, validators.numeric]"
         />
        </template>
        <br>
        <w-select 
            outline
            :items="bandar" 
            label="Bandar *"  
            v-model="form_profil.lkp_bandar_id"
            @input="getPoskod(1)"
            :validators="[validators.required]"/>
        <div class="spacer"></div>
        <br>
        <w-select 
            outline
            :items="negeri" 
            label="Negeri *"  
            v-model="form_profil.lkp_negeri_id"
            @input="getBandar(1)"
            :validators="[validators.required]"/> -->
      </w-form>
        

    
      <template #actions>
         <div class="spacer" />
         <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog_add.show = false">TUTUP</w-button>
         <w-button 
         class="ml1" 
         :loading="dialog_add.loading"
         :disabled="dialog_add.valid === false"
         @click="$refs.form.validate()"
         >
           SIMPAN
         </w-button>
      </template>
    </w-dialog>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'



export default {
  extends: ZResource,
  props: {
    d_form: [Array, Object],
    d_se_pemungutan : [Array, Object],
    d_negeri: [Array, Object],
    d_status: [Array, Object]
  },
  data() {
    return {
      resourceurl: 'se.pengeluaran',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Semen Beku', route: '/se' },
        { label: 'Pengeluaran Semen Beku', route: '/se/pengeluaran' },
      ],
      title : 'Tambah Baka Jantan',
      form : this.d_form,
      se_pemungutan : this.d_se_pemungutan,
      negeri : this.d_negeri,
      status : this.d_status,
      carian_profil: { q: "" },
      country : [],
      bandar : [],
      poskod : [],
      negara : [],
      peran : [],
      form_profil: [],
      user_list: [],
      wajib : 0,
      dialog: {
         valid: false,
         show: false,
         fullscreen: false,
         persistent: true,
         persistentNoAnimation: false,
         loading: false,
         width: 800,
      },
      dialog_add: {
         valid: false,
         show: false,
         fullscreen: false,
         persistent: true,
         persistentNoAnimation: false,
         loading: false,
         width: 800,
         item: {name: '', email: '', mobile: ''}
      },
      
    }
  },
  methods: {
   destroy1(id){
      this.$swal({
        title: 'Anda Pasti?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak'
      }).then((result) => {
        if (result.value) {
          this.$zcomm.delete('pengguna.destroy',{ id: id , pemeriksa:1},{})
          .then(res => {
            // this.sending = false;
            // this.$inertia.visit(this.$page.url)

            this.$zutil.notify("Berjaya dipadam", 'error');
            this.getUserList();
            if (typeof this.onAfterDelete === "function") {
            }
          })
          .finally(() => {
            // $('#' + this.resourceurl).modal('hide')
          });
        }else{ }
        })
   },
   skorKeaktifan(){
      if(this.form.stor_keaktifan > 5){
         this.form.stor_keaktifan = 5;
      }
   },
   pilihNoBatch(value){
      for (var i in this.se_pemungutan) {
         if (this.form.se_pemungutan_id == this.se_pemungutan[i].value) {
            this.form.no_ejekulasi = this.se_pemungutan[i].no_ejekulasi;
            this.form.ternakan = this.se_pemungutan[i].ternakan;
            this.form.lkp_ejakulasi_id = this.se_pemungutan[i].lkp_ejakulasi_id;
            this.form.lkp_ejakulasi_label = this.se_pemungutan[i].lkp_ejakulasi_label; 
            this.form.isipadu = this.se_pemungutan[i].isipadu;
            this.form.se_katalog_id = this.se_pemungutan[i].se_katalog_id;
         }
      }
      // alert('asd');
   },
   countJumlahStraw(){
      if(this.form.kepekatan_sperma && this.form.isipadu && this.form.kepekatan_straw){
         var countisipadu = this.form.kepekatan_sperma * this.form.isipadu;
         var jumlah_straw = Math.round(countisipadu / this.form.kepekatan_straw);
         var isipadu_extender = jumlah_straw * '0.23';

         this.form.isipadu_extender = isipadu_extender - this.form.isipadu;
         this.form.jumlah_straw = jumlah_straw;
      }
   },
   checkPengeluaran() {
  
  if (this.form.lkp_status_id == 24) {
    if (this.form.jumlah_pengeluaran > this.form.jumlah_straw) {
      this.form.jumlah_pengeluaran = this.form.jumlah_straw;
    }
    
    return;
  }

  
  if (this.form.jumlah_pengeluaran > this.form.jumlah_straw) {
    this.form.jumlah_pengeluaran = this.form.jumlah_straw;
  }

  
  if (this.form.jumlah_pengeluaran <= 0) {
    this.form.jumlah_pengeluaran = 1;
  }
},
   checkWajib(){
      if(this.form.lkp_status_id == 24){
         this.wajib = 1
      }else{
         this.wajib = 0
      }
   },
   send(hantar){
      this.form.hantar = hantar
    },
    onSuccess(){
      if(this.form.hantar==1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
               if(this.form.id > 0){
                 this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
                 .then(res => {
                   if (typeof this.onAfterEdit === "function") {
                     this.onAfterEdit()
                   }
                   if (this.form.hantar==1) {
                       this.$inertia.visit(this.$route('se.pengeluaran.show', this.form.id));
                   }else{
                       this.$zutil.notify("Berjaya disimpan", true);
                   }
                   // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
                 })
              }else{
                  this.$zcomm.post(this.resourceurl+'.store' , this.form)
                   .then(res => {
                     if (typeof this.onAfterAdd === "function") {
                       this.onAfterAdd()
                     }
                     this.$zutil.notify("Berjaya disimpan", true);
                     // this.$inertia.visit(window.route('se.pengeluaran.index'));
                     this.$inertia.visit(this.$route('se.pengeluaran.show', res.id))

                   })
              }
            }
          })
      }else{
        if (this.form.id > 0) 
        {
          
          this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            if (this.form.hantar==1) {
                this.$inertia.visit(this.$route('se.pengeluaran.show', this.form.id));
            }else{
                this.$zutil.notify("Berjaya disimpan", true);
                this.$inertia.visit(this.$route('se.pengeluaran.form', this.form.id));
            }
            // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
          })
        }
        else 
        {
          this.$zcomm.post(this.resourceurl+'.store' , this.form)
          .then(res => {
            if (typeof this.onAfterAdd === "function") {
              this.onAfterAdd()
            }
            this.$zutil.notify("Berjaya disimpan", true);
            this.$inertia.visit(this.$route('se.pengeluaran.form', res.id));
            // this.$inertia.visit(this.$route('se.pemungutan.show', res.id))

          })
        }
      } 
      
    },

    setJantina(id){

      this.form.jantina = id
    },

    getJurusan(i){
      this.form.lkp_jurusan_id = ''
      this.$zcomm.get(this.api_service + 'lookup/jurusan/'+i, {}).then(res => {
        this.lkp_jurusan = res
      })
    },

    getBaka(i){
      this.form.lkp_baka_id = ''
      this.$zcomm.get(this.api_service + 'lookup/baka/'+i, {}).then(res => {
        this.lkp_baka = res
      })
    },

    tutup(){
         this.$inertia.visit(window.route('se.pengeluaran.index'));
       },
    
    getNegara(){
      this.$zcomm.get(this.api_service + 'lookup/negara', {}).then(res => {
        this.negara = res
      })
    },

    getBandar(item){
      if (item == 2) {
        this.form_profil.lkp_poskod_id = '';
        this.form_profil.lkp_bandar_id = '';
      }
      if(item == 2 || (item == 1 && this.form_profil.lkp_bandar_id != '')){
        this.$zcomm.get(this.api_service + 'lookup/bandar/'+this.form_profil.lkp_negeri_id, {}).then(res => {
        this.bandar = res
        })
      }
      if(item == 0){
        this.$zcomm.get(this.api_service + 'lookup/bandar/'+this.form_profil.lkp_negeri_id, {}).then(res => {
        this.bandar = res
        })
      }
    },

    getPoskod(item){
      if (item == 2 || this.form_profil.lkp_bandar_id == '') {
      this.form_profil.lkp_poskod_id = '';
      }
      if(item == 2 || (item == 1 && this.form_profil.lkp_bandar_id != '')){
      this.$zcomm.get(this.api_service + 'lookup/poskod/'+this.form_profil.lkp_bandar_id, {}).then(res => {
        this.poskod = res
      })
      }
    },

    getPoskodUtama(){
      this.$zcomm.get(this.api_service + 'lookup/poskod_utama/'+this.form_profil.kode, {}).then(res => {
        // this.form.p = res.p
        this.form_profil.lkp_negeri_id = res.lkp_negeri_id
        this.form_profil.lkp_bandar_id = res.lkp_bandar_id
        this.form_profil.lkp_poskod_id = res.lkp_poskod_id
        this.getPoskod(0)
        this.getBandar(0)
      })
    },

    checkPoskod(){
      if(this.form_profil.lkp_poskod_id == null){
         this.form_profil.p = 0
      }
    },
    tambahPrfile(){
      this.form_profil = {
           id : null,
           no_id : null,
           name : null,
           email:'',
           no_tel: '',
           alamat: '',
           password: 123123,
           pembekal: null,
           status : 1,
           kode: '',
           lkp_poskod_id: '',
           lkp_bandar_id : '',
           lkp_negeri_id :'',
           pemeriksa:1,
      }
      this.dialog_add.show = true
      this.form_profil.saveButton = "Save"
    },
    submitProfil(){
      this.$zcomm.post('pengguna',this.form_profil).then(res => {
          if (res == "No. Kad Pengenalan sudah wujud!" || res == "Email sudah wujud!") {
            if (res == "No. Kad Pengenalan sudah wujud!")
                {
                  this.$zutil.notify("No. Kad Pengenalan sudah wujud!", false);
                }
            if (res == "Email sudah wujud!")
                {
                  this.$zutil.notify("Email sudah wujud!", false);
                }
          }else{
            this.$zutil.notify("Berjaya disimpan");
            this.getUserList();
            this.dialog_add.show = false;
          }
        })
        .catch(err => {
        })
    },
    pengguna(){
      this.getUserList();
      this.dialog.show = true
      this.form.saveButton = "Save"
    },
    pilihProfil(dt) {
        this.form.user_id = dt.value;
        this.form.name = dt.label;
        this.dialog.show = false
    },

    cariProfil() {
        if (this.carian_profil.q.length > 1) {
            this.$zcomm
                .get(
                    this.api_service + "lookup/user_list/3",
                    this.carian_profil,
                    {}
                )
                .then((res) => {
                    this.user_list = res;
                });
        }
    },

    getUserList(){
      this.$zcomm.get(this.api_service + 'lookup/user_list/3', {}).then(res => {
        this.user_list = res
      })
    },

    
  
  },

  watch: {

  },
  mounted() {
    if (this.form.id == 0) {
      var today = new Date();
       this.form.tarikh = today.toISOString().split('T')[0];
    }
    if(this.form.id > 0)
    {
      this.title = 'Kemaskini Pengeluaran Semen Beku '
    }
    else
    {
      this.title = 'Tambah Pengeluaran Semen Beku'
    }
   
    
  }
    
}
</script>
